<app-breadcrumb [master]="'Rozliczenia'" [parentName]="'Faktury'" [name]="'Dodaj'" xmlns="http://www.w3.org/1999/html"></app-breadcrumb>
<div class="risk-configuration-add" fxLayout="column" fxLayoutGap="15px"  >
  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button *ngIf="!checkInvoice" (click)="check()" [class.spinner]="processingRequest" [disabled]="!invoiceForm.valid" mat-stroked-button color="primary"><mat-icon>check</mat-icon> <span> Sprawdź</span></button>
    <button  *ngIf="checkInvoice" (click)="save()" [class.spinner]="processingRequest" [disabled]="!invoiceForm.valid || disabledInvoice" mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>

  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column">
    <div fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">
      <mat-card fxLayout="column">
        <div fxLayout="row">
          <h3>Dane faktury</h3>
        </div>
        <div fxLayout="row" fxLayoutGap="15px" class="invoice-add-flex">
          <app-dict-all-contracts
                  label="Umowa do rozliczenia"
                  [invoiceBlock]="true"
                  [required]="true"
                  [control]="contractControl"
                  [filterPartnership]="false"
                  [addInvoiceContract]="true"
                  [addInvoiceContractTypes]="true"
                  [showElements]="5"
                  (selectedContract)="contractChanged($event); contractChangedSecond($event)"
          ></app-dict-all-contracts>
        </div>
        <div fxLayout="row" fxLayoutGap="15px" class="invoice-add-flex">
      <span *ngIf="blockSubmit" class="warning-text"> Partner posiada aktywną blokadę dodawania faktur </span>
        </div>


<!--        <div fxLayout="row" >-->
<!--          <app-dict-commission-settlement-->
<!--                  fxFlex="100" fxLayoutGap="15px"-->
<!--                  label="Wybierz rozliczenie"-->
<!--                  [required]="true"-->
<!--                  [multiple]="true"-->
<!--                  [commissionSettlement]="commissionSettlement"-->
<!--                  (selectedCommissionSettlement)="selectedCommissionSettlement($event)"-->
<!--          ></app-dict-commission-settlement>-->
<!--        </div>-->
        <app-file-drag-and-drop
          [multiple]="false"
          [generateOutput]="true"
          (fileSelected)="fileSelected($event)"
          [maxSize]="fileMaxSize"
          acceptMime="*/*"
        ></app-file-drag-and-drop>

        <div fxLayout="row" fxLayoutGap="15px">
          <app-month-picker
            fxFlex="50"
            label="Miesiąc rozliczeniowy" [required]="false"
            [control]="billingMonthControl" [disabledDatePicker]="true" [readonly]="true"
          ></app-month-picker>

          <mat-form-field fxFlex="50">
            <mat-label>Numer</mat-label>
            <input matInput placeholder="Numer" [formControl]="numberControl" [required]="true">
            <mat-error *ngIf="numberControl.hasError('required')">To pole jest wymagane</mat-error>
            <mat-error *ngIf="numberControl.hasError('checkInvoiceNumber')">Istnieje już faktura o podanym numerze</mat-error>

          </mat-form-field>
        </div>

        <div fxLayout="row" fxLayoutGap="15px">
          <mat-form-field fxFlex="100">
            <mat-label>Kwota</mat-label>
            <input [required]="true" type="number" matInput placeholder="Kwota" [formControl]="grossControl">
            <mat-error *ngIf="grossControl.hasError('required')">To pole jest wymagane</mat-error>
            <mat-error *ngIf="grossControl.hasError('backendError')">{{grossControl.getError('backendError')}}</mat-error>
          </mat-form-field>
<!--          <mat-form-field [fxFlex]="(!selectedContract && selectedContract?.type?.key !== CONTRACT_TYPE_MANDATE) ? '50' : '25'">-->
<!--            <mat-label>Kwota</mat-label>-->
<!--            <input [required]="true" type="number" matInput placeholder="Kwota" [formControl]="grossControl">-->
<!--            <mat-error *ngIf="grossControl.hasError('required')">To pole jest wymagane</mat-error>-->
<!--            <mat-error *ngIf="grossControl.hasError('backendError')">{{grossControl.getError('backendError')}}</mat-error>-->
<!--          </mat-form-field>-->
<!--          <mat-form-field *ngIf="selectedContract || selectedContract?.type?.key === CONTRACT_TYPE_MANDATE"  [fxFlex]="(selectedContract || selectedContract?.type?.key === CONTRACT_TYPE_MANDATE) ? '25' : '25'">-->
<!--            <mat-label>Kwota podatku</mat-label>-->
<!--            <input [required]="true" type="number" matInput placeholder="Kwota" [formControl]="grossControl">-->
<!--            <mat-error *ngIf="grossControl.hasError('required')">To pole jest wymagane</mat-error>-->
<!--            <mat-error *ngIf="grossControl.hasError('backendError')">{{grossControl.getError('backendError')}}</mat-error>-->
<!--          </mat-form-field>-->
          <app-datepicker
            fxFlex="50"
            label="Data wystawienia"
            placeholder="2000-01-01 00:00"
            [required]="true"
            [control]="issueDateControl"
          ></app-datepicker>
        </div>
        <div fxLayout="row" >
          <mat-form-field fxFlex="100">
            <mat-label>Numer rachunku bankowego</mat-label>
            <input
              prefix="PL" mask=" 00 0000 0000 0000 0000 0000 0000" [dropSpecialCharacters]="false"
              matInput placeholder="PL27 1140 2004 0000 3002 0135 5387" [formControl]="accountNumber">
            <mat-error *ngIf="accountNumber.hasError('invalidIban')">Podaj prawidłowy IBAN</mat-error>
            <mat-error *ngIf="accountNumber.hasError('required')">To pole jest wymagane</mat-error>
            <mat-error *ngIf="accountNumber.hasError('backendError')">{{accountNumber.getError('backendError')}}</mat-error>

          </mat-form-field>
        </div>

<!--        <div fxLayout="row">-->
<!--          <div fxFlex="100">-->
<!--            <mat-slide-toggle class="slide-padding" color="accent" [formControl]="vatInvoiceControl">Faktura VAT</mat-slide-toggle>-->
<!--          </div>-->
<!--        </div>-->
        <div fxLayout="row" >
            <mat-form-field fxFlex="100">
              <mat-label>Uwagi</mat-label>
              <textarea [formControl]="noteControl" matInput placeholder="Uwagi"></textarea>
            </mat-form-field>
        </div>

<!--        <div fxLayout="row">-->
<!--          <div fxFlex="100">-->
<!--            <mat-slide-toggle class="slide-padding" color="accent" [formControl]="checkoutMethodControl">Metoda kasowa</mat-slide-toggle>-->
<!--          </div>-->
<!--        </div>-->

      </mat-card>
    </div>
    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">
      <ng-container *ngIf="contractBalanceContract === contractControl.value">
          <mat-card  fxLayout="column" fxLayoutGap="15px">
          <div fxFlex="100" class="mb-0"><h4>Saldo umowy: </h4></div>
            <div>
              <button (click)="addInitialBalance()" mat-stroked-button color="primary" class="add-button" [disabled]="this.addInitialBalanceButton"> <span>Dodaj saldo</span></button>
            </div>
          <div fxLayout="row" fxFlex="100" fxLayoutGap="15px" >
            <app-detail fxFlex="25" header="Saldo początkowe" [value]=""> {{(contractBalanceInitialBalanceNet === null ? 0 : contractBalanceInitialBalanceNet) | number:'1.2-2'}} zł
            </app-detail>
            <app-detail fxFlex="25" header="Do wypłacenia" [value]="">{{(contractBalanceToPayNet === null ? 0 : contractBalanceToPayNet) | number:'1.2-2'}} zł
            </app-detail>
            <app-detail fxFlex="25" header="Wypłacono" [value]="">{{(contractBalancePaid === null ? 0 : contractBalancePaid) | number:'1.2-2'}} zł
            </app-detail>
            <app-detail fxFlex="25" header="Ogólne" [value]="">{{(contractBalanceTotalCommission === null ? 0 : contractBalanceTotalCommission) | number:'1.2-2'}} zł
            </app-detail>
          </div>
<!--          <div fxLayout="row" fxFlex="100" fxLayoutGap="15px" >-->
<!--            <app-detail fxFlex="25" header="Nota obciążeniowa/uznaniowa" [value]=""> {{(debitNet === null ? 0 : debitNet) | number:'1.2-2'}} zł-->
<!--            </app-detail>-->
<!--            <app-detail fxFlex="25" header="" >-->
<!--            </app-detail>-->
<!--            <app-detail fxFlex="25" header="" >-->
<!--            </app-detail>-->
<!--            <app-detail fxFlex="25" header="" >-->
<!--            </app-detail>-->
<!--          </div>-->

          </mat-card>
        </ng-container>

      <ng-container  *ngIf="isAnyPropertySet()">
        <mat-card class="partners-add-card">
          <div fxLayout="row">
            <h3>Daty związane z działalnością podmiotu</h3>
          </div>

          <div fxLayout="row" fxLayoutGap="15px">
            <div fxFlex="30">
              <app-detail header="Data zawieszenia działalności " [value]="partner.dateOfSuspension | date:'y-MM-dd'" ></app-detail>
            </div>

            <div fxFlex="30">
              <app-detail header="Data wznowienia działalności " [value]="partner.resumptionDate | date:'y-MM-dd'"></app-detail>
            </div>

            <div fxFlex="30">
              <app-detail header="Data zakończenia działalności " [value]=" partner.endDate | date:'y-MM-dd'" ></app-detail>
            </div>
          </div>

          <div fxLayout="row" fxLayoutGap="15px">
            <div fxFlex="30">
              <app-detail header="Data skreślenia działalności z REGON " [value]="partner.deletionRegonData | date:'y-MM-dd'" ></app-detail>
            </div>

            <div fxFlex="30">
              <app-detail header="Data orzeczenia upadłości " [value]="partner.judgmentDeclaringDate | date:'y-MM-dd'"></app-detail>
            </div>

            <div fxFlex="30">
              <app-detail header="Data zakończenia postępowania upadłościowego " [value]=" partner.completionBankruptcyProceedingDate | date:'y-MM-dd'" ></app-detail>
            </div>
          </div>

          <div fxLayout="row" fxLayoutGap="15px">
            <div fxFlex="30">
              <app-detail header="Data skreślenia z rejestru ewidencji " [value]="partner.deletionRegistryData | date:'y-MM-dd'" ></app-detail>
            </div>
          </div>

        </mat-card>

      </ng-container>
      <ng-container *ngIf="dataInvoiceSource.data.length > 0">
          <mat-card  fxLayout="column" fxLayoutGap="15px">
            <table mat-table [dataSource]="dataInvoiceSource">
              <!-- Position Column -->
              <ng-container matColumnDef="number">
                <th mat-header-cell *matHeaderCellDef > Numer faktury </th>
                <td mat-cell *matCellDef="let element">
                  <a class="default-link" [routerLink]="['/faktury/szczegoly', element?.id]">
                    {{element.number}}
                  </a>
                </td>
              </ng-container>

              <ng-container matColumnDef="net" >
                <th mat-header-cell *matHeaderCellDef > Kwota faktury </th>
                <td mat-cell *matCellDef="let element">
                  {{element.net | number:'1.2-2'}} zł
                </td>
              </ng-container>

              <ng-container matColumnDef="download">
                <th mat-header-cell *matHeaderCellDef> Pobierz fakturę </th>
                <td mat-cell *matCellDef="let element">
                  <button (click)="downloadPdf(element)" mat-stroked-button><mat-icon>download</mat-icon> <span> </span></button>
                </td>
              </ng-container>

              <ng-container matColumnDef="issueDate">
                <th mat-header-cell *matHeaderCellDef > Data dodania faktury </th>
                <td mat-cell *matCellDef="let element">
                  {{element.issueDate | date:'y-MM-dd'}}
                </td>
              </ng-container>

              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef > Status </th>
                <td mat-cell *matCellDef="let element">
                  <button mat-raised-button [ngClass]="element.status?.color + '-button'">
                    {{element.status.name}}
                  </button>
                </td>
              </ng-container>

              <ng-container matColumnDef="activeTo">
                <th mat-header-cell *matHeaderCellDef> Data ważności </th>
                <td mat-cell *matCellDef="let element">
                  {{element.activeTo | date:'y-MM-dd'}}
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
          </mat-card>
        </ng-container>
    </div>
  </div>

  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button *ngIf="!checkInvoice" (click)="check()" [class.spinner]="processingRequest" [disabled]="!invoiceForm.valid && blockSubmit" mat-stroked-button color="primary"><mat-icon>check</mat-icon> <span> Sprawdź</span></button>
<!--    <button (click)="check()" [class.spinner]="processingRequest" [disabled]="!invoiceForm.valid" mat-stroked-button color="primary"><mat-icon>check</mat-icon> <span> Sprawdź</span></button>-->
    <button *ngIf="checkInvoice" (click)="save()" [class.spinner]="processingRequest" [disabled]="(!invoiceForm.valid || disabledInvoice) && blockSubmit" mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>
